
// 卡片里显示表格内容，内容为
/**
 * 序号1（如果有左侧列显示左侧列）
 * 列名1： 内容1-1
 */
import { defineComponent, PropType } from "vue";

// 行列内容
interface TypeListItemDetail {
  columnName: string;
  columnContent: string;
}
interface TypeListItem {
  seq: string; // 左侧列名
  contents: TypeListItemDetail[];
}

export default defineComponent({
  name: "DdCardTable",
  components: {},
  props: {
    list: Object as PropType<TypeListItem[]>
  }
});
